import React from "react";
import {
  Box,
  Button,
  Chip,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomSelectFile from "../../../comman/CustomSelectFile";
// import CustomSelectFile from "@/components/Common/CustomSelectFile";

const ServiceSchema = Yup.object().shape({
  serviceId: Yup.string().required("Service ID is required"),
  remarks: Yup.array().of(Yup.string()),
  thumbnail: Yup.mixed().nullable(), // since file can be object, not just URL
});

export default function AddEditService({
  defaultData = {},
  serviceId = "",
  onSave = () => { },
}) {
  const formik = useFormik({
    initialValues: {
      serviceId: serviceId || "",
      remarks: defaultData?.remarks || [],
      thumbnail: defaultData?.thumbnail,
    },
    validationSchema: ServiceSchema,
    onSubmit: (values) => {

      const payload = {
        ...values,
        remarks: values.remarks.filter((r) => r.trim() !== ""),
      };
      onSave(payload);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack spacing={2}>
        {/* Thumbnail */}
        <CustomSelectFile
          id="selectService"
          title="Thumbnail (Jpeg,png,jpg)"
          onChange={(file) => formik.setFieldValue("thumbnail", file)}
          files={formik.values.thumbnail}
        />

        {/* Remarks (dynamic chips) */}
        <Box>
          <Typography variant="subtitle2" gutterBottom>
            Remarks
          </Typography>
          <TextField
            fullWidth
            size="small"
            onKeyDown={(e) => {
              if (e.key === "Enter" && e.target.value.trim()) {
                e.preventDefault();
                formik.setFieldValue("remarks", [
                  ...formik.values.remarks,
                  e.target.value.trim(),
                ]);
                e.target.value = "";
              }
            }}
          />

          <Stack direction="row" flexWrap="wrap" gap={1} my={1}>
            {formik.values.remarks.map((remark, idx) => (
              <Chip
                key={idx}
                label={remark}
                onDelete={() =>
                  formik.setFieldValue(
                    "remarks",
                    formik.values.remarks.filter((_, i) => i !== idx)
                  )
                }
                color="primary"
                variant="outlined"
              />
            ))}
          </Stack>
        </Box>

        {/* Save */}
        <Button type="submit" variant="contained">
          Save
        </Button>
      </Stack>
    </form>
  );
}
